<template>
  <div>
    <!-- Summary Display Tables -->
    <div class="summary-tables">
      <table class="summary-table">
        <tr>
          <th>Normal Stunden</th>
          <td class="right">{{ summary.normal_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Überstunden</th>
          <td class="right">{{ summary.overtime_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Urlaub</th>
          <td class="right">{{ summary.vacation_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Zeitausgleich</th>
          <td class="right">{{ summary.compensation_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Krankenstand</th>
          <td class="right">{{ summary.sick_leave_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr class="sum">
          <th>Summe</th>
          <td class="right">{{ summary.summary_sum.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
      </table>
      <table class="summary-table">
        <tr :class="['check-row', { isOK: isCheckOK }]">
          <th class="sum">Kontrollrechnung</th>
          <td>{{ summary.check_hours.toFixed(2) }}</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
      </table>
      <table class="summary-table">
        <tr>
          <th>Privat km</th>
          <td class="right">{{ summary.privat_km_sum }}</td>
          <td>km</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
      </table>
      <table class="summary-table">
        <tr>
          <th>Produktive</th>
          <td>&nbsp;</td>
          <td></td>
        </tr>
        <tr>
          <th>Normal Stunden</th>
          <td class="right">{{ summary.normal_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Überstunden</th>
          <td class="right">{{ summary.overtime_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Summe</th>
          <td class="right">{{ summary.summary_productive.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
      </table>
      <table class="summary-table">
        <tr>
          <th>Unproduktive</th>
          <td>&nbsp;</td>
          <td></td>
        </tr>
        <tr>
          <th>Urlaub</th>
          <td class="right">{{ summary.vacation_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Zeitausgleich</th>
          <td class="right">{{ summary.compensation_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Krankenstand</th>
          <td class="right">{{ summary.sick_leave_hours.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>Summe</th>
          <td class="right">{{ summary.summary_unproductive.toFixed(2) }}</td>
          <td>Stunden</td>
        </tr>
        <tr>
          <th>&nbsp;</th>
          <td>&nbsp;</td>
        </tr>
      </table>
    </div>

    <!-- Handsontable for detailed data -->
    <div id="hot"></div>
  </div>
</template>

<script>
import PVDataTable from './PVDataTable.vue';

export default {
  name: 'PVDataTableListenansicht',
  extends: PVDataTable,
  data() {
    return {
      summary: {
        normal_hours: 0,
        overtime_hours: 0,
        vacation_hours: 0,
        compensation_hours: 0,
        sick_leave_hours: 0,
        summary_sum: 0,
        check_hours: 0,
        privat_km_sum: 0,
        summary_productive: 0,
        summary_unproductive: 0
      }
    };
  },
  watch: {
    selectedWeek(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetSummary(); // Reset summary values
        this.fetchData(this.load_data_action);
      }
    },
    selectedYear(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.resetSummary(); // Reset summary values
        this.fetchData(this.load_data_action);
      }
    }
  },
  computed: {
    isCheckOK() {
      return this.summary.check_hours.toFixed(2) === '38.50';
    }
  },
  methods: {
    storeFetchedData(responseData) {
      // Call the original method to store table data
      this.data = responseData.data;
      this.columnConfig = responseData.columnConfig;
      this.columnTitles = responseData.columnTitles;
      this.sortOrder = responseData.sortOrder;
      this.sumRow = responseData.sumRow;
      this.fixedColumns = responseData.fixedColumns || 0;

      // Extract summary data from API response, if available
      if (responseData.summary) {
        this.summary = {
          normal_hours: responseData.summary.normal_hours || 0,
          overtime_hours: responseData.summary.overtime_hours || 0,
          vacation_hours: responseData.summary.vacation_hours || 0,
          compensation_hours: responseData.summary.compensation_hours || 0,
          sick_leave_hours: responseData.summary.sick_leave_hours || 0,
          summary_sum: responseData.summary.summary_sum || 0,
          check_hours: responseData.summary.check_hours || 0,
          privat_km_sum: responseData.summary.privat_km_sum || 0,
          summary_productive: responseData.summary.summary_productive || 0,
          summary_unproductive: responseData.summary.summary_unproductive || 0
        };
      }
    },
    resetSummary() {
      this.summary = {
        normal_hours: 0,
        overtime_hours: 0,
        vacation_hours: 0,
        compensation_hours: 0,
        sick_leave_hours: 0,
        summary_sum: 0,
        check_hours: 0,
        privat_km_sum: 0,
        summary_productive: 0,
        summary_unproductive: 0
      };
    }
  }
};
</script>

<style>
.summary-tables {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
  text-align: left;
}

.summary-table {
  padding: 0 10px;
  border-right: 1px solid lightgray;

  &:last-child {
    border-right: none;
  }
}

.summary-table .right {
  text-align: right;
}

.summary-table th {
  padding-right: 10px;
}

.summary-table .sum {
  font-weight: bold;
}

.check-row {
  font-weight: bold;
  background-color: #f44343; /* Default color is red */
  color: white;
}

.check-row.isOK {
  background-color: #4caf50; /* Turns green when condition is met */
}
</style>